<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2">
            <v-row>
                <v-col>
                    <v-form ref="form" @submit.prevent="save">
                        <sarala-table
                            :model="model"
                            ref="table"
                            @itemsFetched="itemsFetched"
                        >
                            <template #partner="{ item }">
                                <v-radio-group v-model="item.partner" row>
                                    <v-radio
                                        :label="$t('form.status.active')"
                                        color="success"
                                        :value="true"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('form.status.disabled')"
                                        color="red"
                                        :value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                            <template #whitelabel="{ item }">
                                <v-radio-group v-model="item.whitelabel" row>
                                    <v-radio
                                        :label="$t('form.status.active')"
                                        color="success"
                                        :value="true"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('form.status.disabled')"
                                        color="red"
                                        :value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                            <template #action="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            v-on="on"
                                            :to="{
                                                name: 'plans.module',
                                                params: { id: item.id },
                                            }"
                                        >
                                            <v-icon color="blue-grey" v-on="on"
                                                >mdi-format-list-bulleted-square</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{
                                        $t('plans.actions.show-modules')
                                    }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            v-on="on"
                                            :to="{
                                                name: 'plans.edit',
                                                params: { id: item.id },
                                            }"
                                        >
                                            <v-icon color="blue-grey" v-on="on"
                                                >mdi-pencil</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('form.actions.edit') }}</span>
                                </v-tooltip>
                            </template>
                        </sarala-table>

                        <FormActions
                            :loadingSave="loading"
                            :showBackButton="false"
                        />
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import FormActions from '@/components/utils/FormActions'
import SaralaTable from '@/shared/components/SaralaTable'
import Plan from '@/models/plans/Plan'
import _ from 'lodash'

export default {
    components: {
        FormActions,
        'sarala-table': SaralaTable,
    },

    data: () => {
        return {
            loading: false,
            items: null,
        }
    },

    computed: {
        model() {
            return new Plan()
        },
    },

    methods: {
        itemsFetched(items) {
            this.items = items
        },

        async save() {
            this.loading = true

            let data = this.getDataUpdated()

            let res = null
            try {
                res = await this.$http.put('config-plans-batch', data)
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('plans.form.feedback.success-batch'),
            )

            this.$refs.table.getItems()
        },

        getDataUpdated() {
            let data = { plans: [] }

            _.each(this.items, plan => {
                data.plans.push({
                    id: plan.id,
                    partner: plan.partner,
                    whitelabel: plan.whitelabel,
                })
            })

            return data
        },
    },
}
</script>
